export var ENCORE_ADS_BUSINESS_DATA_IDS = {
  AdsBox: 'ads_adsBox',
  AdsChip: 'ads_adsChip',
  AdsFormGroup: 'ads_adsFormGroup',
  AdsFormInput: 'ads_adsFormInput',
  AdsFormTextarea: 'ads_adsFormTextarea',
  AdsMenu: 'ads_adsMenu',
  AdsMenuDropdown: 'ads_adsMenuDropdown',
  AdsMenuItem: 'ads_adsMenuItem',
  AdsTable: 'ads_adsTable',
  AdsTableActionBar: 'ads_adsTableActionBar',
  AdsTableCell: 'ads_adsTableCell',
  AdsTableCheckbox: 'ads_adsTableCheckbox',
  AdsTableFilterRow: 'ads_adsTableFilterRow',
  AdsTableFilterRowItem: 'ads_adsTableFilterRowItem',
  AdsTableHeaderCell: 'ads_adsTableHeaderCell',
  AdsTableLink: 'ads_adsTableLink',
  AdsTableLoadingSkeleton: 'ads_adsTableLoadingSkeleton',
  AdsTablePagination: 'ads_adsTablePagination',
  AdsTableProvider: 'ads_adsTableProvider',
  AdsTableRadio: 'ads_adsTableRadio',
  AdsTableRow: 'ads_adsTableRow',
  AdsTableThumbnail: 'ads_adsTableThumbnail',
  AdsTableToolbarRow: 'ads_adsTableToolbarRow',
  AdsTableToolbarRowItem: 'ads_adsTableToolbarRowItem',
  AudioPlayer: 'ads_audioPlayer',
  ExpandableSearch: 'ads_expandableSearch',
  AccordionFormGroup: 'ads_accordionFormGroup',
  CheckableFormGroup: 'ads_checkableFormGroup',
  CollapsibleFormGroup: 'ads_collapsibleFormGroup',
  EditableFormGroup: 'ads_editableFormGroup',
  EnhancedFormGroup: 'ads_enchantedFormGroup',
  FullScreenLayout: 'ads_fullScreenLayout',
  LabelGroup: 'ads_labelGroup',
  LoadingSkeletonCircle: 'ads_loadingSkeletonCircle',
  LoadingSkeletonLine: 'ads_loadingSkeletonLine',
  LoadingSkeletonSquare: 'ads_loadingSkeletonSquare',
  LogoSpotifyAdvertising: 'ads_logoSpotifyAdvertising',
  PlaybackScrubber: 'ads_playbackScrubber',
  MegaSelector: 'ads_megaSelector',
  PlayPauseButton: 'ads_playPauseButton',
  PlaybackTimecode: 'ads_playbackTimecode',
  RadioListRow: 'ads_radioListRow',
  RadioTable: 'ads_radioTable',
  RoundedIcon: 'ads_roundedIcon',
  Separator: 'ads_separator',
  Stack: 'ads_stack',
  HStack: 'ads_hstack',
  VStack: 'ads_vstack',
  AdsTextLink: 'ads_adsTextLink',
  Uploader: 'ads_uploader',
  VideoMobilePreview: 'ads_videoMobilePreview',
  VideoPlayer: 'ads_videoPlayer',
  VisualPicker: 'ads_visualPicker'
};